// Import all model templates
import ServiceProvider from "./ServiceProvider";
import DispatchUser from "./DispatchUser";
import MyProfile from "./MyProfile";
import Driver from "./Driver";
import FareConfiguration from "./FareConfiguration";
import GeoZone from "./GeoZone";
import Account from "./Account";
import ServiceJurisdiction from "./ServiceJurisdiction";
import Shift from "./Shift";

// A function to return a model based on the model name
export function Model(modelName) {
    switch (modelName) {
        case 'ServiceProvider':
            return ServiceProvider;
        case 'DispatchUser':
            return DispatchUser;
        case 'MyProfile':
            return MyProfile;
        case 'Driver':
            return Driver;
        case 'FareConfiguration':
            return FareConfiguration;
        case 'GeoZone':
            return GeoZone;
        case 'Account':
            return Account;
        case 'ServiceJurisdiction':
            return ServiceJurisdiction;
        case 'Shift':
            return Shift;
        default:
            throw new Error(`Unknown model name: ${modelName}`);
    }
}
